import React, { useEffect } from 'react';
import TooltipNew from './TooltipNew';
import { Box, Button, Typography } from '@mui/material';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';

const ConfigurableTooltip = ({
  config,
  children,
}: {
  config: { title: string; description: string[]; ctaText: string; ctaURL?: string };
  children: React.ReactElement;
}) => {
  const { title, description, ctaText, ctaURL } = config;

  return (
    <TooltipNew
      title={title}
      content={
        <>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            {description.map((line, i) => (
              <Typography key={i} variant="body2" color="text.secondary">
                {line}
              </Typography>
            ))}
          </Box>
          {ctaURL && (
            <Button
              variant="text"
              color="primary"
              size="small"
              onClick={() => window.open(ctaURL, '_blank')}
              sx={{ mt: 1, pl: 0, fontWeight: 800, letterSpacing: '0.5px', display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
              endIcon={<OpenInNewRoundedIcon sx={{ fontSize: 14 }} />}
            >
              {ctaText}
            </Button>
          )}
        </>
      }
    >
      {children}
    </TooltipNew>
  );
};

export default ConfigurableTooltip;
